import {mapMutations} from "vuex";

export default {
    methods: {
        ...mapMutations('ad',{
            'setAdList':"setAdList"
        }),
        init(filters, sort) {
            this.adLoad = false;

            let th = this;
            this.setFiltersCount(this.addFilersName().length);
            this.load = true;
            //this.$store.state.dataCarsLoadedFlag = false;

            this.$http
                .post(
                    `${this.api}/new-cars/get?access-token=${this.accessToken}${
                        this.$route.name == "CarsInStock" ? "&status=2" : ""
                    }`,
                    {
                        filters: filters,
                        sort: sort,
                        total_load: this.total_load,
                    },
                    {
                        before(request) {
                            if (this.previousRequest) {
                                this.previousRequest.abort();
                            }
                            this.previousRequest = request;
                        },
                    }
                )
                .then((response) => {
                    if (
                        th.$store.state.isApp &&
                        typeof navigator.splashscreen == "object"
                    ) {
                        navigator.splashscreen.hide();
                    }

                    th.busy = false;
                    th.load = false;
                    let res = {};
                    Object.assign(res, th.d);
                    for (let k in response.body) {
                        res[k] = response.body[k];
                    }

                    /*if (res.res) {
                        if (th.total_load > 0) {
                            const dRes = th.d.res || [];
                            res.res = dRes.concat(res.res);
                        }
                        th.total_load = res.res.length;
                    }*/

                    res.price_f = {mi: 0, ma: 20000000};
                    this.filtersClean.verd = [res.price_f.mi, res.price_f.ma];

                    this.setData({
                        field: "dealers.page",
                        data: res,
                    });

                    this.insertAd();

                    this.$store.state.resultCount = th.d.resultCount;
                    this.$store.state.sub = th.d.is_sub;

                    this.$store.state.dataCarsLoadedFlag = true;

                    //this.$store.state.specialText = response.body.special_text;
                    this.easter = response.body.easter;

                    document.dispatchEvent(new Event('renderer-ready'));
                    if (this.filtersCount == 0) {
                        this.getAd({location: this.frontPage}).then(res => {
                            this.adLoad = true;
                            if (res.data.status) {
                                this.ad = res.data.ad;
                            }
                        });
                    }
                })
                .catch((e) => {
                    console.log("Caught", e);
                });
        },
    },
}
